
import { Link } from 'react-router-dom';
import { portfolioEvents } from '../../../mocks/portfolioEvents';

interface RelatedEventsProps {
  currentSlug: string;
  currentCategory: string;
}

export default function RelatedEvents({ currentSlug, currentCategory }: RelatedEventsProps) {
  const related = portfolioEvents
    .filter((e) => e.slug !== currentSlug)
    .sort((a, b) => (a.category === currentCategory ? -1 : 1) - (b.category === currentCategory ? -1 : 1))
    .slice(0, 3);

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-px bg-emerald-400"></div>
          <span className="text-emerald-600 text-xs font-semibold tracking-[0.2em] uppercase">More Work</span>
        </div>
        <h2 className="text-3xl md:text-4xl font-display text-stone-900 mb-12">
          Related <span className="italic text-stone-400">Events</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-6">
          {related.map((event) => (
            <Link
              key={event.id}
              to={`/event/${event.slug}`}
              className="group bg-white rounded-2xl overflow-hidden border border-stone-100 hover:shadow-xl hover:border-emerald-100 transition-all duration-500"
            >
              <div className="w-full h-52 overflow-hidden relative">
                <img
                  src={event.after}
                  alt={event.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-stone-900/40 to-transparent"></div>
                <span className="absolute top-3 left-3 px-3 py-1 bg-emerald-500/20 backdrop-blur-sm text-emerald-200 text-xs font-semibold rounded-full border border-emerald-400/20">
                  {event.category}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-serif font-semibold text-stone-900 group-hover:text-emerald-700 transition-colors mb-2">
                  {event.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-stone-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-map-pin-line text-emerald-400"></i>
                    {event.location.split(',')[1]?.trim()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-group-line text-emerald-400"></i>
                    {event.guests} guests
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
